/**
 * Tipos compartidos a nivel app — rutas, theming, etc.
 */

/** Routing AetherLite (hash-based, ver Root en App.tsx). */
export type Route =
  // Editor user
  | "dashboard"
  | "templates"
  | "clients"
  | "agenda"
  | "library"
  | "measurements"
  | "brand"
  | "config"
  | "plan-builder"
  | "share-link"
  // Admin (solo is_admin)
  | "admin-dashboard"
  | "admin-users"
  | "admin-payments"
  | "admin-coupons"
  | "admin-reports"
  | "admin-foods"
  | "admin-exercises"
  | "admin-admins"
  | "admin-audit-log"
  | "admin-assets"
  | "admin-ai-usage"
  // Pública
  | "public-plan"
  // Misc
  | "login"
  | "terms"
  | "privacy";

/** Etiquetas usadas en el TopBar para cada ruta. */
export const ROUTE_TITLES: Partial<Record<Route, string>> = {
  dashboard: "Inicio",
  templates: "Plantillas",
  clients: "Clientes",
  agenda: "Agenda",
  library: "Biblioteca de ejercicios",
  measurements: "Medidas",
  brand: "Mi marca",
  config: "Configuración",
  "plan-builder": "Editor de plan",
  "share-link": "Compartir plan",
  "admin-dashboard": "Centro de control · Nilabs",
  "admin-users": "Usuarios · Admin",
  "admin-payments": "Pagos · Admin",
  "admin-coupons": "Cupones · Admin",
  "admin-reports": "Reportes · Admin",
  "admin-foods": "Alimentos · Admin",
  "admin-exercises": "Ejercicios · Admin",
  "admin-admins": "Administradores · Nilabs",
  "admin-audit-log": "Registro de actividad",
  "admin-assets": "Biblioteca de assets · Nilabs",
  "admin-ai-usage": "Uso de IA · Admin",
  "public-plan": "Plan compartido",
  login: "Iniciar sesión",
  terms: "Términos y condiciones",
  privacy: "Política de privacidad",
};

export interface Tweaks {
  theme: "light" | "dark";
  primaryColor: string;
  accentColor: string;
  fontDisplay: string;
  fontBody: string;
  density: "comfortable" | "compact";
}

export const DEFAULT_TWEAKS: Tweaks = {
  theme: "light",
  primaryColor: "#7c3aed", // violeta AetherLite
  accentColor: "#ec4899",  // magenta acento
  fontDisplay: "Bricolage Grotesque",
  fontBody: "Inter Tight",
  density: "comfortable",
};
